<template>
	<div :style="{backgroundColor: 'rgba(255, 246, 233, 1)'}" class="testing flex start-v">
		<!-- 做题 -->
		<RemnCard v-show="!done" ref="testcard" :questionList="questionList" @questionDone="done=true"/>

		
	</div>
</template>

<script>
import RemnCard from "./child/remnCard.vue";

export default {
	components: {
		RemnCard
	},
	data() {
		return {
			done: false,
			questionList:[],

			backSeconds: 0,
			backTimer: null,
		};
	},
	
	mounted() {
		// let answerDuration = this.$route.query.answerDuration;
		// if(answerDuration){
		// 	this.backSeconds = answerDuration*60;
		// 	this.backTimer = setInterval(() => {
		// 		if(this.backSeconds<0){
		// 			clearInterval(this.backTimer);
		// 		}
		// 		else this.backSeconds--;
		// 	}, 1000);
		// }
		this.getQuestionList();
	},

	methods: {
		async getQuestionList() {
			let { testId } = this.$route.query;
			try {
				let {success,message,result} = await this.$http.get(`h5/examineTest/getExamineTestSubject?testId=${testId}`)
				if(!success) throw new Error(message);
				this.questionList = result;
			} catch (error) {
				console.log("getQuestionList", error?.message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.testing {
	height: 100%;
	padding: 25 / @rem 17 / @rem 30 / @rem;
}
</style>
